import { Button, ButtonsGroup, Modal, ModalProps, useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useSegment } from '../../../../../../../../hooks'
import { useXRechnungEInvoicingAddressForm } from '../../../../contexts/xRechnungEInvoicingAddressFormContext'

type DownloadAsXRechnungModalFooterProps = Pick<ModalProps, 'id'>

export const DownloadAsXRechnungModalFooter = ({ id }: DownloadAsXRechnungModalFooterProps): ReactElement => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const { close: closeDownloadAsXRechnungModal } = useModal(id)
  const { isSubmitting, submitForm, validate } = useXRechnungEInvoicingAddressForm()

  const handleCancelButtonClick = useCallback(() => {
    closeDownloadAsXRechnungModal()
  }, [closeDownloadAsXRechnungModal])

  const handleDownloadButtonClick = useCallback(async () => {
    const isFormValid = await validate()

    if (isFormValid) {
      track('XXX - Invoicing Core - Invoice Editor - Download as XRechnung modal - Download now')
      submitForm()
      closeDownloadAsXRechnungModal()
    }
  }, [closeDownloadAsXRechnungModal, submitForm, track, validate])

  return (
    <Modal.Footer>
      <ButtonsGroup>
        <Button disabled={isSubmitting} variant="text" onClick={handleCancelButtonClick}>
          {t('cancel')}
        </Button>
        <Button disabled={isSubmitting} loading={isSubmitting} onClick={handleDownloadButtonClick}>
          {t('external_invoices.download_as_xrechnung.modal.action.download_now')}
        </Button>
      </ButtonsGroup>
    </Modal.Footer>
  )
}
